module.exports = __webpack_public_path__ + "img/quizz.78c2d765.png";